let INSTANCE: AppMetaInfo | null = null;


export class AppMetaInfo {
    constructor(
        public stripePK: string,
        public stripePT: string,
        public stripeBP: string,
    ){}

    static async Instance(): Promise<AppMetaInfo> {
        if(!INSTANCE){
            console.log('Fetching app meta info from server');
            const meta = await fetch('/api/dashboard');
            const data = await meta.json();
            INSTANCE = new AppMetaInfo(
                data.stripePK, data.stripePT, data.stripeBP
            );
        }
        return INSTANCE;
    }

    getTableID(key?: string | null): string {
        switch(key){
            case null:
            case undefined:
            default: return this.stripePT;
        }
    }
}